// px
import { SHARE_TYPE } from '../menu/share/shareConstants';

export const MAIN_MENU_MIN_SIZE = 64;
export const MAIN_MENU_OPEN_SIZE = 240;
export const MENU_INFO_OPEN_SIZE = 360;
export const MENU_INFO_CLOSE_SIZE = 0;
export const HEADER_SIZE = 60;
export const PANEL_HEADER_HEIGHT = 56;
export const INSTALL_BANNER_SIZE = 60;
export const GLOBAL_GRAPH_HEIGHT_SIZE = 200;

export const BBOX_COORDS_DECIMALS = 5;
export const WEATHER_COORDS_DECIMALS = 5;

export const POI_LAYER_ID = 'poi-layer';
export const SEARCH_LAYER_ID = 'search-layer';
export const EXPLORE_LAYER_ID = 'explore-layer';

export const GPX = 'GPX';
export const FAVOURITES = 'FAVOURITES';

export const FILE_WAS_DELETED = 'file was deleted';

export const MAIN_PAGE_TYPE = 'main';
export const MAIN_URL = '/map';
export const MAIN_URL_WITH_SLASH = '/map/';

// The live map hash (#z/lat/lng) straight from the browser. leaflet-hash writes the map
// position to the URL via location.replace(), bypassing React Router, so React Router's
// useLocation().hash is stale. Any navigate()/replaceState that re-applies that stale hash
// clobbers the live map position and makes the map snap back. For map-mode navigations always
// carry this live value instead of location.hash.
export function liveHash() {
    return globalThis.location.hash || '';
}

export const SEARCH_URL = 'search/';
export const EXPLORE_URL = 'explore/';
export const POI_CATEGORIES_URL = 'poi-categories/';
export const SEARCH_RESULT_URL = 'result/';
export const POI_URL = 'poi/';
export const STOP_URL = 'stop/';
export const MAP_OBJ_URL = 'obj/';

export const CONFIGURE_URL = 'configure/';
export const WEATHER_URL = 'weather/';
export const WEATHER_FORECAST_URL = 'forecast/';

export const TRACKS_URL = 'mydata/tracks/';
export const VISIBLE_TRACKS_URL = 'visible-tracks/';

export const FAVORITES_URL = 'mydata/favorites/';
export const NAVIGATE_URL = 'navigate/';
export const PLANROUTE_URL = 'plan/';
export const SETTINGS_URL = 'settings/';
export const TRACK_ANALYZER_URL = 'track-analyzer/';
export const TRAVEL_URL = 'travel/';
export const LOGIN_URL = 'account/';
export const PURCHASES_URL = 'purchases/';
export const GARMIN_URL = 'garmin/';
export const DELETE_ACCOUNT_URL = 'delete-account/';
export const SHARE_FILE_URL = 'share/join/:uuid';
export const SHARE_FILE_MAIN_URL = 'share/join/';
export const INFO_MENU_URL = 'info/';
export const SHARE_MENU_URL = 'share/';
export const PRICING_URL = 'pricing/';

export const MENU_IDS = {
    search: 'se-show-menu-search',
    config: 'se-show-menu-configuremap',
    weather: 'se-show-menu-weather',
    tracks: 'se-show-menu-tracks',
    favorites: 'se-show-menu-favorites',
    navigation: 'se-show-menu-navigation',
    planroute: 'se-show-menu-planroute',
    settings: 'se-show-menu-settings',
    trackanalyzer: 'se-show-menu-track-analyzer',
    travel: 'se-show-menu-travel',
};

export const isTravelPath = (pathname) => pathname?.includes(TRAVEL_URL);

export const openPricingPage = (featureId) =>
    window.open(`/${PRICING_URL}?source=pro#${featureId}`, '_blank', 'noopener,noreferrer');

export function getUniqFileId(file) {
    return `_id_${file.name}_${file.userid}`;
}

export function getFileStorage({ ctx, smartf, type }) {
    if (type === GPX) {
        return smartf?.type === SHARE_TYPE ? ctx.shareWithMeFiles?.tracks : ctx.gpxFiles;
    }
    return null;
}

export function updateFileStorage({ ctx, smartf, type, file }) {
    if (type === GPX) {
        return smartf?.type === SHARE_TYPE
            ? ctx.setShareWithMeFiles((prev) => ({ ...prev, tracks: { ...prev.tracks, [file.name]: file } }))
            : ctx.setGpxFiles((prev) => ({ ...prev, [file.name]: file }));
    }
    return null;
}

export function showProcessingNotification(
    ctx,
    message = "We're working hard to prepare maps for you! 💪🧭",
    timeout = 3000
) {
    return setTimeout(() => {
        ctx.setNotification({
            text: message,
            severity: 'info',
        });
    }, timeout);
}
